import SiteBody from './SiteBody';

export default SiteBody;
